/**
 * Generated by orval v8.17.0 🍺
 * Do not edit manually.
 * MDLink
 * In the documentation API requests will be sent from currently logged in user so you do not need to provide a bearer token manually. <br><br> When calling API from outside the documentation, you will need to provide an access token for all requests in authorization header: `Authorization: Bearer <Token>` <br> You can create a new access token in your account settings page.
 * OpenAPI spec version: 1.0.0
 */
import type {ArchiveLinkOverlaysBody} from './schemas/archive-link-overlays-body';

import type {CreateLinkOverlay200} from './schemas/create-link-overlay200';

import type {CrupdateLinkOverlayBody} from './schemas/crupdate-link-overlay-body';

import type {DeleteLinkOverlaysParams} from './schemas/delete-link-overlays-params';

import type {ListLinkOverlaysParams} from './schemas/list-link-overlays-params';

import type {ListLinkOverlays200} from './schemas/list-link-overlays200';

import type {RetrieveLinkOverlay200} from './schemas/retrieve-link-overlay200';

import type {UnarchiveLinkOverlaysBody} from './schemas/unarchive-link-overlays-body';

import type {UpdateLinkOverlay200} from './schemas/update-link-overlay200';

import {orvalApiFetch} from '../../../common/foundation/resources/client/http/query-client';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Retrieve a link overlay
 */
export const retrieveLinkOverlay = (
  id: number,
  options?: SecondParameter<typeof orvalApiFetch<RetrieveLinkOverlay200>>,
) => {
  return orvalApiFetch<RetrieveLinkOverlay200>(
    {url: `/link-overlays/${id}`, method: 'GET'},
    options,
  );
};
/**
 * @summary Update a link overlay
 */
export const updateLinkOverlay = (
  id: number,
  crupdateLinkOverlayBody?: CrupdateLinkOverlayBody,
  options?: SecondParameter<typeof orvalApiFetch<UpdateLinkOverlay200>>,
) => {
  return orvalApiFetch<UpdateLinkOverlay200>(
    {
      url: `/link-overlays/${id}`,
      method: 'PUT',
      headers: {'Content-Type': 'application/json'},
      data: crupdateLinkOverlayBody,
    },
    options,
  );
};
/**
 * @summary List all link overlays
 */
export const listLinkOverlays = (
  params?: ListLinkOverlaysParams,
  options?: SecondParameter<typeof orvalApiFetch<ListLinkOverlays200>>,
) => {
  return orvalApiFetch<ListLinkOverlays200>(
    {url: `/link-overlays`, method: 'GET', params},
    options,
  );
};
/**
 * @summary Create a link overlay
 */
export const createLinkOverlay = (
  crupdateLinkOverlayBody?: CrupdateLinkOverlayBody,
  options?: SecondParameter<typeof orvalApiFetch<CreateLinkOverlay200>>,
) => {
  return orvalApiFetch<CreateLinkOverlay200>(
    {
      url: `/link-overlays`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: crupdateLinkOverlayBody,
    },
    options,
  );
};
/**
 * @summary Delete link overlays
 */
export const deleteLinkOverlays = (
  params: DeleteLinkOverlaysParams,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {url: `/link-overlays/bulk`, method: 'DELETE', params},
    options,
  );
};
/**
 * @summary Archive link overlays
 */
export const archiveLinkOverlays = (
  archiveLinkOverlaysBody: ArchiveLinkOverlaysBody,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {
      url: `/link-overlays/bulk/archive`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: archiveLinkOverlaysBody,
    },
    options,
  );
};
/**
 * @summary Unarchive link overlays
 */
export const unarchiveLinkOverlays = (
  unarchiveLinkOverlaysBody: UnarchiveLinkOverlaysBody,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {
      url: `/link-overlays/bulk/unarchive`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: unarchiveLinkOverlaysBody,
    },
    options,
  );
};
export type RetrieveLinkOverlayResult = NonNullable<
  Awaited<ReturnType<typeof retrieveLinkOverlay>>
>;
export type UpdateLinkOverlayResult = NonNullable<
  Awaited<ReturnType<typeof updateLinkOverlay>>
>;
export type ListLinkOverlaysResult = NonNullable<
  Awaited<ReturnType<typeof listLinkOverlays>>
>;
export type CreateLinkOverlayResult = NonNullable<
  Awaited<ReturnType<typeof createLinkOverlay>>
>;
export type DeleteLinkOverlaysResult = NonNullable<
  Awaited<ReturnType<typeof deleteLinkOverlays>>
>;
export type ArchiveLinkOverlaysResult = NonNullable<
  Awaited<ReturnType<typeof archiveLinkOverlays>>
>;
export type UnarchiveLinkOverlaysResult = NonNullable<
  Awaited<ReturnType<typeof unarchiveLinkOverlays>>
>;
